import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Florida ePlan": {
    parameters: {
      linkUrls: ["https://tier2.erplan.net/onlinefiling/filingLogin.htm"],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: true,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "ePlan",
    state: "FL",
  },
  "Florida 312 Exemption Form": {
    parameters: {
      linkUrls: [
        "https://www.floridadisaster.org/globalassets/business/sod_dereg-form-revised-04.2025.pdf",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "FL",
  },
};
